var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5322,
    r: 15,
    fill: "#1D3A55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4963 22.0319L23.5 22.0313V16.5301C23.5 13.8388 22.9206 11.7657 19.7744 11.7657C18.2619 11.7657 17.2469 12.5957 16.8325 13.3826H16.7887V12.017H13.8056V22.0313H16.9119V17.0726C16.9119 15.767 17.1594 14.5045 18.7762 14.5045C20.3694 14.5045 20.3931 15.9945 20.3931 17.1563V22.0319H23.4963Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7475 12.018H11.8575V22.0324H8.7475V12.018Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3012 7.03223C9.30687 7.03223 8.5 7.8391 8.5 8.83348C8.5 9.82785 9.30687 10.6516 10.3012 10.6516C11.2956 10.6516 12.1025 9.82785 12.1025 8.83348C12.1019 7.8391 11.295 7.03223 10.3012 7.03223Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3cbc41c22bfafccb5400b715f90c2d75.svg";
export { ForwardRef as ReactComponent };